module.exports = __webpack_public_path__ + "static/logo_one2one-799935ea3a88c131f96901d3faea416d.png";